import { useSidebar } from "../ui/sidebar";

export function LogoView() {
  const { state, toggleSidebar } = useSidebar();
  return (
    <div className="flex w-[22rem] shrink-0 items-center justify-center gap-1 px-8">
      <img
        src="/images/logo.png"
        alt="회사 로고"
        width={175}
        height={42}
        className="h-[42px] w-[175px] cursor-pointer object-contain"
        onClick={toggleSidebar}
      />
    </div>
  );
}
